<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.codetable.pageHeader') }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col class="pb-0 pt-0 mt-0" cols="12" lg="6" md="6">
        <v-row class="custom-form-control custom-figma-1 mb-0">
          <v-col cols="12" class="pt-0 pb-0">
            <v-row>
              <v-col
                class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
                cols="12"
                lg="12"
                md="12"
              >
                <v-row>
                  <v-col cols="12" lg="12" md="12" class="pt-0 pb-0 mb-0 arrow-btn-custom">
                    <div class="d-inline-flex">
                      <v-btn
                        :disabled="!$auth.manage"
                        class="btn-width-1 btn btn-top btn-search"
                        color="primary"
                        @click="openAddCodeTable"
                      >
                        <v-icon x-small class="mr-2">fa fa-plus</v-icon>
                        {{ $t('btn.common.add') }}
                      </v-btn>
                      <v-text-field
                        v-model="searchGroup"
                        :label="$t('lbl.common.conditionSearch.findbyDBBroker')"
                        class="custom-selectbox find-group-code pl-2"
                        dense
                        filled
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="code-table-hidden-div"></v-row>
        <v-row>
          <v-col cols="12" lg="12" md="12" class="pt-1 pb-0">
            <v-data-table
              :search="searchGroup"
              :headers="SummaryList.headers"
              :hide-default-footer="true"
              :fixed-header="true"
              :items="codeGroupData"
              :sort-desc="true"
              :height="tableHeight"
              :class="[
                'list-table code-table srm-list-table custom-border-table',
                codeGroupData.length > 0 ? '' : 'custom-border-table-not-data',
              ]"
              item-key="ROWID"
              disable-pagination
              sort-by="CODE_UPD_DT"
              @current-items="currentGroupItems"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="item.ROWID"
                    @click="onClickCodeGroup(item)"
                    :class="[
                      selectedRowGroup == item.CODE_CTG_ID || (selectedRowGroup == '' && index == 0)
                        ? 'selected_row'
                        : '',
                    ]"
                  >
                    <td class="col-codegroup">{{ item.CODE_CTG_NAME }}</td>
                    <td class="text-center">{{ item.CODE_UPD_DT }}</td>
                    <td>{{ item.CODE_UPD_USR }}</td>
                    <td class="text-center">
                      <a
                        v-if="isDlb"
                        style="text-decoration: underline;cursor:pointer"
                        id="codelist"
                        download="codelist.txt"
                        @click.stop="downloadCodeList(item)"
                      >
                        <v-btn x-small text icon>
                          <icon-svg iconName="download" />
                        </v-btn>
                      </a>
                      <v-btn
                        :disabled="!$auth.manage"
                        x-small
                        text
                        icon
                        @click.stop="openModifyCodeTable(item)"
                      >
                        <icon-svg :disabled="!$auth.manage" iconName="edit" />
                      </v-btn>
                      <v-btn
                        :disabled="!$auth.manage"
                        x-small
                        text
                        icon
                        @click.stop="deleteItem(item)"
                      >
                        <icon-svg :disabled="!$auth.manage" iconName="delete" />
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pb-0 pt-0 mt-0" cols="12" lg="6" md="6">
        <v-row
          class="custom-form-control custom-form-control-type-2 code-data-section custom-figma-1"
        >
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="12"
            md="12"
          >
            <v-row>
              <v-col class="pb-0 pt-0" cols="12" lg="4" md="4">
                <v-text-field
                  v-model="searchCode"
                  :label="$t('lbl.common.conditionSearch.findbyCodeName')"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" cols="12" lg="4" md="4">
                <v-text-field
                  v-model="codeDataPoolItems.data[0].SRC_CD"
                  :label="$t('lbl.common.conditionSearch.findbySourceCode')"
                  @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" cols="12" lg="4" md="4">
                <v-text-field
                  v-model="codeDataPoolItems.data[0].TRG_CD"
                  :label="$t('lbl.common.conditionSearch.findbyTargetCode')"
                  @keyup.enter="queryCodeDataPool(selectedRowLinked)"
                  class="custom-selectbox"
                  height="40"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="btn-form-control code-tbl-btn-control">
          <v-col cols="12" class="pt-0 pb-0 pl-0">
            <v-row>
              <v-col cols="12" lg="8" md="8" class="pt-0 pb-0 pr-0">
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <v-checkbox
                    v-model="checkbox"
                    @change="checkAllCode"
                    class="mt-0 pt-0"
                    hide-details
                    dense
                    solo
                  ></v-checkbox>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <span class="all-code-label mr-5">{{ $t('lbl.codetable.checkboxLabel') }}</span>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <span class="code-table-label">{{ $t('lbl.codetable.codeLabelInfo') }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0 text-right">
                <v-btn class="btn btn-top btn-add" @click="openCodeTableDialog">{{
                  $t('btn.codetable.codeDataPool')
                }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-row no-gutters>
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
              <v-col cols="12" lg="5" md="5">
                <v-data-table
                  :height="tableHeight"
                  :search="searchCode"
                  :headers="CodeName.headers"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  :items="codeLinkedData"
                  :class="[
                    'list-table code-table srm-list-table custom-border-table',
                    codeLinkedData.length > 0 ? '' : 'custom-border-table-not-data',
                  ]"
                  item-key="ROWID"
                  disable-pagination
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="item.ROWID"
                        @click="onClickCodeDataPool(item)"
                        :class="[
                          selectedRowLinked == item.CODE_GRP_CD ||
                          (selectedRowLinked == '' && index == 0)
                            ? 'selected_row'
                            : '',
                        ]"
                      >
                        <td class="text-center">{{ item.ROWID }}</td>
                        <td>{{ item.CODE_GRP_CD }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" lg="7" md="7" class="code-data-range">
                <v-data-table
                  :headers="CodeData.headers"
                  :items="dataPoolList"
                  :fixed-header="true"
                  :footer-props="{ showFirstLastPage: true }"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  :height="tableHeightDataPool"
                  :class="[
                    'list-table code-table srm-list-table custom-border-table',
                    dataPoolList.length > 0 ? '' : 'custom-border-table-not-data',
                  ]"
                  hide-default-footer
                  no-data-text="No matching records found"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                        @click="onClickCodeSourceTarget(item)"
                        :class="[selectedRowPool == item.CODE_ITM_NO ? 'selected_row' : '']"
                      >
                        <td class="text-center">
                          {{
                            searchSource != '' || searchTarget != ''
                              ? index + 1
                              : (page - 1) * itemsPerPage + index + 1
                          }}
                        </td>
                        <td>{{ item.CODE_ITM_SRC_CD }}</td>
                        <td>{{ item.CODE_ITM_TRG_CD }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
                <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
                  <v-col class="page-control-content page-control-bg transaction-pagi">
                    <v-row>
                      <v-col lg="12" md="12">
                        <v-row>
                          <v-col class="page-control-bg text-left pa-0" cols="4">
                            <div class="custom-pagi-selectbox">
                              <v-select
                                @change="queryCodeDataPool(selectedRowLinked)"
                                v-model="itemsPerPage"
                                hide-details
                                dense
                                solo
                                :items="rowPerPage"
                                class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                              >
                              </v-select>
                            </div>
                          </v-col>
                          <v-col class="page-control-bg text-right pa-0" cols="8">
                            <button
                              type="button"
                              @click="handlePageChange(1)"
                              :class="[
                                'custom-btn-first-last-paging',
                                page == 1 ? ' v-pagination__navigation--disabled' : '',
                              ]"
                            >
                              <div class="ml-2 pr-2 d-inline">
                                <span><i class="fa fa-sm fa-step-backward"></i></span>
                              </div>
                            </button>
                            <button
                              type="button"
                              @click="changePageByTextbox(-1)"
                              :class="[
                                'mr-3 custom-btn-first-last-paging',
                                page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                              ]"
                            >
                              <div class="ml-2 pr-2 d-inline">
                                <span><i class="fa fa-lg fa-caret-left"></i></span>
                              </div>
                            </button>
                            <v-text-field
                              v-model="pageEnter"
                              hide-details
                              dense
                              solo
                              class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                              @keyup.enter="changePageByTextbox(0)"
                            ></v-text-field
                            ><label>/ {{ pageCount }}</label>
                            <button
                              type="button"
                              @click="changePageByTextbox(1)"
                              :class="[
                                'ml-3 custom-btn-first-last-paging',
                                page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                              ]"
                            >
                              <div class="mr-2 pl-2 d-inline">
                                <span><i class="fa fa-lg fa-caret-right"></i></span>
                              </div>
                            </button>
                            <button
                              type="button"
                              @click="handlePageChange(pageCount)"
                              :class="[
                                'custom-btn-first-last-paging',
                                page == pageCount ? ' v-pagination__navigation--disabled' : '',
                              ]"
                            >
                              <div class="mr-2 pl-2 d-inline">
                                <span><i class="fa fa-sm fa-step-forward"></i></span>
                              </div>
                            </button>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.codetable.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteFile($event)"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="validateAddCode"
      size="max"
      title="warning"
      :detail="$t('msg.codetable.noSelectItem')"
      color="validation"
      :showCancel="false"
    ></dialogWindow>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <addCodeTable
        v-if="dialog.type == 'addCodeTable'"
        class="maplist-layout-dialog add-code-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @refreshData="refreshGroupList($event)"
      ></addCodeTable>
      <codeDataPool
        v-if="dialog.type == 'CodeDataPool'"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        :id="dialog.id"
        ref="CodeDataPool"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @refreshData="checkAllCode"
      ></codeDataPool>
    </div>
  </div>
</template>
<script>
/* globals Store */

import { mapState } from 'vuex';
import $ from 'jquery';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import addCodeTable from '@/vue-caas/views/codetable/AddCodeGroup.vue';
import codeDataPool from '@/vue-caas/views/codetable/CodeDataPool.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';
import config from '@/vue-caas/config/config.js';

export default {
  components: {
    dialogWindow,
    addCodeTable,
    codeDataPool,
    SystemProgress,
    IconSvg,
  },
  computed: {
    ...mapState('codetable', {
      codetables: 'codetables',
      codeLinkedGroup: 'codeLinkedGroup',
      codeDataPool: 'codeDataPool',
      codeGroupList: 'codeGroupList',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('map', {
      mapData: 'mapData',
      codeListResult: 'codeListResult',
    }),
  },

  data() {
    return {
      page: 1,
      pageCount: 1,
      pageEnter: 1,
      itemsPerPage: 100, // amount of rows will get when scroll
      tableHeight: '',
      tableHeightDataPool: '',
      rowPerPage: [
        { value: 100, text: 'Show 100' },
        { value: 200, text: 'Show 200' },
        { value: 500, text: 'Show 500' },
      ],
      listPage: [{ value: 1, text: 'Page 1' }],
      isCreated: false,
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      checkbox: false,
      selectedRowGroup: '',
      selectedRowGroupData: '',
      selectedRowLinked: '',
      selectedRowLinkedData: '', //2020.12.8-203728-IssueCommon27-Shoulde select the 1st row of the Code Group list when enter the menu.
      selectedRowPool: '',
      dataPoolList: [],
      codeLinkedData: [],
      searchGroup: '',
      searchCode: '',
      searchSource: '',
      searchTarget: '',
      deleteData: '',
      deleteDataName: '',
      codeGroupData: [],
      totalCnt: 1,
      SummaryList: {
        headers: [
          {
            text: this.$t('tbl.codetable.codeGroupTable.codeGroup'),
            value: 'CODE_CTG_NAME',
            align: 'center',
            width: '250px',
          },
          {
            text: this.$t('tbl.codetable.codeGroupTable.lastUpdate'),
            value: 'CODE_UPD_DT',
            align: 'center',
            width: '150px',
          },
          {
            text: this.$t('tbl.codetable.codeGroupTable.updateUser'),
            value: 'CODE_UPD_USR',
            align: 'center',
          },
          {
            text: this.$t('tbl.codetable.codeGroupTable.manager'),
            value: '',
            align: 'center',
            sortable: false,
            width: '120px',
          },
        ],
      },
      CodeName: {
        headers: [
          {
            text: this.$t('tbl.codetable.codeNameTable.no'),
            value: 'ROWID',
            align: 'center',
            width: '75px',
          },
          {
            text: this.$t('tbl.codetable.codeNameTable.codeName'),
            value: 'CODE_GRP_CD',
            align: 'center',
          },
        ],
      },
      CodeData: {
        headers: [
          {
            text: this.$t('tbl.codetable.codeDataTable.no'),
            value: 'ROWID',
            align: 'center',
            width: '75px',
          },
          {
            text: this.$t('tbl.codetable.codeDataTable.sourceCode'),
            value: 'CODE_ITM_SRC_CD',
            width: '120px',
            align: 'center',
          },
          {
            text: this.$t('tbl.codetable.codeDataTable.targetCode'),
            value: 'CODE_ITM_TRG_CD',
            align: 'center',
          },
        ],
      },
      groupListSearchItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
          },
        ],
      },
      codeLinkedGroupItems: {
        header: ['CTG_ID'],
        data: [
          {
            CTG_ID: '',
          },
        ],
      },
      codeDataPoolItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID', 'GRP_CD', 'SRC_CD', 'TRG_CD', 'R_FROM', 'R_TO', 'SORT'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
            GRP_CD: '',
            SRC_CD: '',
            TRG_CD: '',
            R_FROM: 1,
            R_TO: this.itemsPerPage,
            SORT: 'DEFAULT',
          },
        ],
      },
      allCodeItems: {
        header: ['CUST_ID', 'OWNR_CUST_ID', 'CTG_ID'],
        data: [
          {
            CUST_ID: '',
            OWNR_CUST_ID: '',
            CTG_ID: '',
          },
        ],
      },
      deleteItems: {
        header: ['CTG_ID'],
        data: [
          {
            CTG_ID: '',
          },
        ],
      },
      addDataItems: [
        {
          header: ['CTG_ID', 'CUST_ID', 'CTG_NM'],
          data: [
            {
              CTG_ID: '',
              CUST_ID: 'cyberlogitec.com',
              CTG_NM: 'CLV_TEST_DATA',
            },
          ],
        },
        {
          header: ['CTG_ID', 'STATUS', 'GRP_CD'],
          data: [
            {
              CTG_ID: '',
              STATUS: 'I',
              GRP_CD: 'WEIGHT_UNIT',
            },
          ],
        },
      ],
      codeListCreate: {
        header: ['CODE_CTG_ID', 'DIV_KUBUN', 'SITE_CODE', 'SUB_DIR'],
        data: [
          {
            CODE_CTG_ID: '',
            DIV_KUBUN: 'ASSET',
            SITE_CODE: '',
            SUB_DIR: '',
          },
        ],
      },
      storeDataPool: [],
      isLoading: false,
      dataDownload: [],
      isDlb: false,
    };
  },
  watch: {
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    downloadCodeList(item) {
      this.isLoading = true;
      this.codeListCreate.data[0].CODE_CTG_ID = item.CODE_CTG_ID;
      this.codeListCreate.data[0].SITE_CODE = $cookies.get('comp-id');
      this.codeListCreate.data[0].SUB_DIR = item.CODE_CTG_NAME;

      Store.dispatch('map/createCodeList', this.codeListCreate).then(() => {
        if (this.codeListResult[0].successFlag === 'SUCCESS') {
          let downloadfile = new DownloadFile();
          downloadfile.data[0].FILE_ID = this.codeListResult[0].returnFileID;
          downloadfile.data[0].SAVE_NAME = 'code_list.txt';
          Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
            console.log('--------- Finished to process ----------');
            this.isLoading = false;
          });
        }
      });
    },
    currentGroupItems: function(value) {
      if (typeof value !== 'undefined' && value.length > 0) {
        let check = value.includes(this.selectedRowGroupData);
        if (!check) {
          this.codeLinkedData = [];
          this.dataPoolList = [];
        } else {
          this.codeLinkedData = this.codeLinkedGroup;
          this.dataPoolList = this.codeDataPool;
        }
      } else {
        this.codeLinkedData = [];
        this.dataPoolList = [];
      }
    },
    currentCodeItems: function(value) {
      if (typeof value !== 'undefined' && value.length > 0) {
        let check = value.includes(this.selectedRowLinkedData);
        if (!check) {
          this.dataPoolList = [];
        } else {
          this.dataPoolList = this.codeDataPool;
        }
      } else {
        this.dataPoolList = [];
      }
    },
    getGroupList() {
      this.groupListSearchItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.groupListSearchItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      Store.dispatch('codetable/codetables', this.groupListSearchItems).then(() => {
        this.codeGroupData = this.codetables;
        let count = this.codetables.length;
        if (typeof this.codetables !== 'undefined' && count > 0) {
          this.selectedRowGroup = this.codetables[count - 1].CODE_CTG_ID;
          this.selectedRowGroupData = this.codetables[count - 1];
          this.queryCodeLinkedGroup(this.selectedRowGroup);
        }
      });
    },
    queryCodeLinkedGroup(item) {
      this.codeLinkedGroupItems.data[0].CTG_ID = item;
      Store.dispatch('codetable/codeLinkedGroup', this.codeLinkedGroupItems).then(() => {
        this.codeLinkedData = this.codeLinkedGroup;
        if (this.codeLinkedGroup.length > 0) {
          this.selectedRowLinked = this.codeLinkedGroup[0].CODE_GRP_CD;
          this.selectedRowLinkedData = this.codeLinkedGroup[0];
          this.codeDataPoolItems.data[0].SRC_CD = '';
          this.codeDataPoolItems.data[0].TRG_CD = '';
          this.queryCodeDataPool(this.codeLinkedGroup[0].CODE_GRP_CD);
        }
      });
    },
    queryCodeDataPool(item, resetPage = true) {
      this.isLoading = true;
      if (resetPage) this.page = 1;
      this.codeDataPoolItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.codeDataPoolItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.codeDataPoolItems.data[0].GRP_CD = item;

      this.codeDataPoolItems.data[0].R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.codeDataPoolItems.data[0].R_TO = this.itemsPerPage * this.page;
      Store.dispatch('codetable/codeDataPoolPaging', this.codeDataPoolItems)
        .then((res) => {
          this.dataPoolList = res.codeDataPool;
          this.totalCnt = res.totalDataPool;
          this.caculatePageCount();
          if (res.codeDataPool.length > 0) {
            this.selectedRowPool = res.codeDataPool[0].CODE_ITM_NO;
            this.storeDataPool = this.dataPoolList;
          }
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    refreshGroupList(item) {
      this.groupListSearchItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.groupListSearchItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
      Store.dispatch('codetable/codetables', this.groupListSearchItems).then(() => {
        this.codeGroupData = this.codetables;
        this.selectedRowGroup = item.CODE_CTG_ID;
        this.selectedRowGroupData = item;
        this.queryCodeLinkedGroup(this.selectedRowGroup);
      });
    },
    openCodeTableDialog(codeCtg) {
      let type = 'CodeDataPool';
      let item = {
        ROWID: 0,
        codeCtg: this.codeCtg,
      };
      let indexArrDialog = this.findDialog('CodeDataPool_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    onClickCodeGroup(item) {
      this.checkbox = false;
      this.selectedRowGroup = item.CODE_CTG_ID;
      this.selectedRowGroupData = item;
      if (item.CODE_CTG_ID != undefined && item.CODE_CTG_ID != null)
        this.queryCodeLinkedGroup(item.CODE_CTG_ID);
    },
    onClickCodeDataPool(item) {
      this.selectedRowLinked = item.CODE_GRP_CD;
      this.selectedRowLinkedData = item;
      if (item.CODE_GRP_CD != undefined && item.CODE_GRP_CD != null) {
        this.codeDataPoolItems.data[0].SRC_CD = '';
        this.codeDataPoolItems.data[0].TRG_CD = '';
        this.queryCodeDataPool(item.CODE_GRP_CD);
      }
    },
    onClickCodeSourceTarget(item) {
      this.selectedRowPool = item.CODE_ITM_NO;
    },
    checkAllCode() {
      if (this.checkbox) {
        this.allCodeItems.data[0].CUST_ID = this.$cookies.get('comp-id');
        this.allCodeItems.data[0].OWNR_CUST_ID = this.$cookies.get('ownr-id');
        this.allCodeItems.data[0].CTG_ID = '';
        Store.dispatch('codetable/codeGroupList', this.allCodeItems).then(() => {
          this.codeLinkedData = this.codeGroupList;
          this.codeDataPoolItems.data[0].SRC_CD = '';
          this.codeDataPoolItems.data[0].TRG_CD = '';
          this.queryCodeDataPool(this.codeGroupList[0].CODE_GRP_CD);
        });
      } else {
        if (this.selectedRowGroup != '') {
          this.queryCodeLinkedGroup(this.selectedRowGroup);
        } else {
          this.codeLinkedData = [];
        }
      }
    },
    deleteItem(item) {
      this.deleteData = item.CODE_CTG_ID;
      this.deleteDataName = item.CODE_CTG_NAME;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    okDeleteFile(item) {
      this.deleteItems.data[0].CTG_ID = item;
      Store.dispatch('codetable/deleteTable', this.deleteItems).then(() => {
        this.getGroupList();
      });
    },
    addCodeData() {
      Store.dispatch('codetable/addCategory', this.addDataItems).then(() => {
        this.getGroupList();
      });
    },
    openAddCodeTable() {
      let type = 'addCodeTable';
      let item = {
        ROWID: 0,
        action: 'add',
        selectedRow: this.selectedRowGroupData,
      };
      let indexArrDialog = this.findDialog('addCodeTable_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifyCodeTable(rowItem) {
      let type = 'addCodeTable';
      let item = {
        ROWID: 0,
        action: 'modify',
        selectedRow: rowItem,
      };
      let indexArrDialog = this.findDialog('addCodeTable_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    handlePageChange(value) {
      this.page = value;
      this.queryCodeDataPool(this.selectedRowLinked, false);
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.queryCodeDataPool(this.selectedRowLinked, false);
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },
  created() {
    this.getGroupList();
    this.isCreated = true;
    this.isDlb = config.isDlb;
  },

  updated: function() {
    let self = this;
    let arrClassMinus = [];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 30 + 'px';
      self.tableHeightDataPool = h1 - 5 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 30 + 'px';
      self.tableHeightDataPool = h1 - 5 + 'px';
    });
  },
};
</script>

<style>
.find-group-code.custom-selectbox .v-input__slot {
  width: 260px;
}
.find-table-code.custom-selectbox .v-input__slot {
  width: 200px;
}
.all-code-label {
  color: #bbbbbb;
  margin-left: 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 30px;
}
.code-table-section .v-input__control,
.code-table-section .v-input__control .v-input__slot {
  height: 30px;
}
.code-table-section .v-input__control .v-input__slot label {
  font-size: 14px;
}
.theme--dark .code-table.v-data-table tbody tr.selected_row {
  background: #243645 !important;
}
.theme--light .code-table.v-data-table tbody tr.selected_row {
  background: #eaf1f8 !important;
}
.code-table .fa-pen:hover,
.code-table .fa-trash-alt:hover {
  color: #0082ba;
}
.maplist-layout-dialog.add-code-dialog {
  width: 1405px !important;
  height: auto !important;
}
.code-modify-icon {
  margin-right: 10px;
}
.code-table-hidden-div {
  height: 32px;
}
.code-data-range {
  padding-left: 15px !important;
}
#page-count-custom.flat-table-pagination .v-pagination__navigation {
  width: 70px !important;
  height: 27px !important;
  margin-right: 0px;
  margin-left: 8px;
  margin-top: 7px;
}
.custom-pagination-figma-v3-last .data-table-filter-text-field {
  max-width: 60px;
}
</style>
